import { CarrierAgreementData } from './carrier-agreement-data';
import { UserAdminData } from './user-admin-data';

export interface CarrierUsersData {
  users: UserAdminData[];
  carrierAgreements: CarrierAgreementData[];
}
